// extracted by mini-css-extract-plugin
export var settingsList = "_3g-0";
export var settingsRow = "_3g-1";
export var warningDot = "_3g-2";